import i18next from "i18next";
import type { ToastMessage } from "./types";

/**
 * Resolve a toast message key to display text via i18next `t()`. If the key is missing (or
 * i18n hasn't initialized yet), `defaultValue` shows the key itself, so nothing ever crashes or
 * renders blank and a missing translation is easy to spot.
 *
 * Imports the i18next default instance (inert until initI18n() runs in main.tsx), so this
 * stays off the side-effect-free @core root path.
 */
export function resolveMessage(message: ToastMessage): string {
  return i18next.t(message.key, {
    defaultValue: message.key,
    ...message.vars,
  });
}
